import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'localTimeFromUTC'
})
export class LocalTimeFromUTC implements PipeTransform {
    transform(UTCTime: string): string {
        let localtime = (new Date(UTCTime).getHours() > 10 ? new Date(UTCTime).getHours() : "0" + new Date(UTCTime).getHours())
            + ":" + (new Date(UTCTime).getMinutes() > 10 ? new Date(UTCTime).getMinutes() : "0" + new Date(UTCTime).getMinutes())
            + ":" + (new Date(UTCTime).getSeconds() > 10 ? new Date(UTCTime).getSeconds() : "0" + new Date(UTCTime).getSeconds());

        return localtime;
    }
}